import { View } from 'react-native';
import styled from 'styled-components/native';

export const Container = styled(View)`
    width: 100%;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    top: 0;
`;

export const Element = styled(View)`
    margin-top: 8px;
    width: 48px;
    height: 6px;
    border-radius: 100px;
`;
